export default "__VITE_ASSET__DP5aYND9__"